import { render, staticRenderFns } from "./DormUsers.vue?vue&type=template&id=15d17237&scoped=true&"
import script from "./DormUsers.vue?vue&type=script&lang=js&"
export * from "./DormUsers.vue?vue&type=script&lang=js&"
import style0 from "./DormUsers.vue?vue&type=style&index=0&id=15d17237&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d17237",
  null
  
)

export default component.exports